export default function Home(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip-home)">
				<path d="M7.5 15V10.5H10.5V15H14.25V9H16.5L9 2.25L1.5 9H3.75V15H7.5Z" fill="currentColor" />
			</g>
			<defs>
				<clipPath id="clip-home">
					<rect width="18" height="18" fill="currentColor" />
				</clipPath>
			</defs>
		</svg>
	)
}
